// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__J8B0C","text":"styles_text__mxQT_","bullets_wrapper":"styles_bullets_wrapper__njr6e"};